import Markdown from "react-markdown";
import TermsOfService from "./tos.md?raw";

export const TOS = () => {
	return (
		<div className="sm:w-2/3 place-self-center text-lg [&>*]:p-4 [&>*]:text-justify [&>ul]:list-disc">
			<Markdown>{TermsOfService}</Markdown>
		</div>
	);
};
